<template>
  <div class="homepage">
    <div class="container">
      <div class="homepage__add-batch">
        <button class="btn btn--turqoise" @click="openQrScannerPopup">
          Add batch
        </button>
      </div>
      <div class="popup" v-if="qrScannerPopup">
        <div class="popup__inner">
          <div class="qr-scanner-popup">
            <div
              id="video"
              class="qr-scanner-popup__video-container"
              v-if="showVideo"
            >
              <div class="video-inner">
                <video id="video-view"></video>
                <div class="qr-placeholder"></div>
              </div>
            </div>
            <div class="qr-scanner-popup__form">
              <input
                class="input"
                v-model="batchId"
                type="text"
                placeholder="Batch ID"
              />
              <button class="btn btn--turqoise" @click="add">ADD</button>
            </div>
            <button
              class="btn btn--turqoise qr-scanner-popup__cancel"
              @click="closeQrScannerPopup"
            >
              X
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2 class="margin-top margin-bottom">In Progress</h2>
          <InProcess />
          <h2 class="margin-top margin-bottom">History</h2>
          <History />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BrowserQRCodeReader } from "@zxing/library";
import firebase from "firebase/app";
import InProcess from "@/views/home/components/InProcess";
import History from "@/views/home/components/History";

const newChip = {
  id: "",
  comments: "",
  status: "NEW",
  tests: {}
};
const newBatch = {
  id: "",
  chips: [newChip, newChip, newChip],
  status: "INPROGRESS",
  createdAt: firebase.firestore.FieldValue.serverTimestamp()
};

export default {
  name: "Home",
  components: {
    InProcess,
    History
  },
  data() {
    return {
      batchId: undefined,
      qrScannerPopup: false,
      showVideo: false,
      video: undefined
    };
  },
  methods: {
    async add() {
      this.closeQrScannerPopup();
      let batchId = this.batchId.trim();
      if (batchId.length > 0) {
        const db = firebase.firestore();

        try {
          const snapshot = await db
            .collection("batches")
            .where("batchId", "==", batchId)
            .get();
          if (snapshot.docs.length) {
            console.log("batch already exists");
            return false;
          }

          await db.collection("batches").add({
            ...newBatch,
            id: batchId,
            tester: this.$store.getters["auth/user"].email
          });
          this.$router.push({ name: "Batch", params: { batchId } });
        } catch (err) {
          console.log(err);
        }
      }
    },
    async openQrScannerPopup() {
      this.qrScannerPopup = true;
      const codeReader = new BrowserQRCodeReader();
      this.showVideo = true;
      this.video = codeReader;

      try {
        const result = await codeReader.decodeOnceFromVideoDevice(
          undefined,
          "video-view"
        );
        this.show = false;
        this.batchId = result.text;
        this.add();
      } catch (err) {
        console.log(err);
      }
    },
    async closeQrScannerPopup() {
      this.qrScannerPopup = false;
      this.video.reset();
      this.showVideo = false;
    }
  }
};
</script>
